"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performSamlConfirmation = void 0;

var _catchError = require("rxjs/operators/catchError");

var _fromPromise = require("rxjs/observable/fromPromise");

var _map = require("rxjs/operators/map");

var _of = require("rxjs/observable/of");

var _startWith = require("rxjs/operators/startWith");

var _API = _interopRequireDefault(require("./API"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var performSamlConfirmation = function performSamlConfirmation(getState) {
  var request = (0, _selectors.getConfirmationRequest)(getState());
  return (0, _fromPromise.fromPromise)(_API.default.getLoginRedirect(request)).pipe((0, _map.map)(function (_ref) {
    var redirectUrl = _ref.redirectUrl;

    _API.default.openWindow(redirectUrl);

    return _actions.FetchSamlLoginRedirectUrl.success(redirectUrl, request);
  }), (0, _catchError.catchError)(function (error) {
    return (0, _of.of)(_actions.FetchSamlLoginRedirectUrl.failure(error, request));
  }), (0, _startWith.startWith)(_actions.FetchSamlLoginRedirectUrl.request(request)));
};

exports.performSamlConfirmation = performSamlConfirmation;